import React from 'react';

import { css } from '@emotion/css';
import { theme } from 'theme';

/**
 * Shared container for the recharts custom tooltips on the inventory dashboard charts.
 * Standardizes the box styling (background, radius, border, padding). Each chart passes its own
 * content as children and an optional `borderColor` (e.g. the hovered series/slice color).
 */
export function ChartTooltip({
  borderColor = theme.colors.neutral[400],
  children,
}: {
  borderColor?: string;
  children: React.ReactNode;
}) {
  return (
    <div
      className={css`
        background-color: rgba(255, 255, 255, 0.95);
        font-weight: 500;
        border-radius: 8px;
        border: 2px solid ${borderColor};
        box-shadow: 0px 0px 2px 0px ${theme.colors.neutral[400]};
        padding: 6px;
      `}
    >
      {children}
    </div>
  );
}
